import { useId, useState } from "react";
import { FiLock, FiEye, FiEyeOff } from "react-icons/fi";

type Props = {
  label: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  autoComplete?: string;
  id?: string;
  required?: boolean;
};

export default function PasswordField({
  label,
  value,
  onChange,
  placeholder = "••••••••",
  autoComplete = "current-password",
  id,
  required = true,
}: Props) {
  const uid = useId();
  const inputId = id || uid;
  const [show, setShow] = useState(false);

  return (
    <div>
      <label htmlFor={inputId} className="mb-1 block text-xs font-medium text-gray-700">
        {label}
      </label>
      <div className="relative">
        <FiLock className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
        <input
          id={inputId}
          type={show ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="w-full rounded-xl border border-gray-300 bg-white px-9 py-2 pr-10 text-sm text-gray-900 outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-500/20"
          required={required}
          autoComplete={autoComplete}
        />
        <button
          type="button"
          onClick={() => setShow((s) => !s)}
          className="absolute right-2 top-1/2 -translate-y-1/2 grid h-8 w-8 place-items-center rounded-md text-gray-600 hover:bg-gray-100"
          aria-label={show ? "Hide password" : "Show password"}
        >
          {show ? <FiEyeOff /> : <FiEye />}
        </button>
      </div>
    </div>
  );
}
